<template>
    <div id="thank-you" class="container">
        <div class="content-wrapper">
            <div :style="`background-image: url('/assets/images/banner-commande.webp')`" class="image"></div>
            <div class="content">

                <div class="text">
                    <svg id="alpha" height="0" width="0">
                        <!--  <path d="M-1,0 -1,1 0.45,1 C 0.55,1 0.65,0.90  0.70,0.75 L 1,0 z"/>-->
                        <defs>
                            <clipPath id="alphaPath" clipPathUnits="objectBoundingBox">
                                <path d="M0.42 0 1,0 1,1 0,1 C0,1 0.16,1  0.21,0.78"/>
                            </clipPath>
                        </defs>
                    </svg>
                    <div class="text-content">

                        <h1 class="sf-heading__title" v-html="$t('thanksOrder')"></h1>
                        <p class="order">{{ $t('Order N°:') }}
                            <SfLink :link="$localizePath('/mon-compte/commandes?order='+orderNumber)"
                                    class="order-link">
                                {{ orderNumber }}
                            </SfLink>
                        </p>
                        <p class="order-text">{{ $t('order.text') }}</p>
                        <div class="order-actions">
                            <SfButton :link="$localizePath('/')" class="color-white-bg text-secondary-color"> {{
                                $t('back to home')
                                }}
                            </SfButton>
                            <SfButton :link="$localizePath('/mon-compte/commandes?order='+orderNumber)"
                                      class="color-white-bg">
                                {{ $t('Show my order') }}
                            </SfButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {SfLink, SfHeading, SfButton} from '@storefront-ui/vue';
import Api from "@/api/Api";
import {Order} from "@/models/order";
import GtagEvent from "@/utils/GtagEvent";

export default {
    components: {
        SfHeading,
        SfLink,
        SfButton,
    },
    data() {
        return {
            orderNumber: null,
            UuId: this.$router.history.current.params.order
        }
    },
    created() {
        this.getOrderNumber();
    },
    methods: {

        getOrderNumber() {
            if (this.UuId) {
                sessionStorage.removeItem("empowerment")
                sessionStorage.removeItem("empowermentClient")
                this.$store.dispatch('setCart', null);
            }
            Api.order.getByCartUuid(this.UuId).then((data) => {
                const order = Order.of(data)
                if (order) {
                    this.orderNumber = order.reference
                    GtagEvent.purchase(order)
                }
            })
                .catch((e) => {
                    console.error(e)
                })
        }
    }
};
</script>

<style lang="scss" scoped>
#thank-you {
  margin-top: var(--spacer-base);
  box-sizing: border-box;
  @include for-desktop {
    margin-top: var(--spacer-2xl);
  }
}

@include for-mobile {
  .container {
    padding: 0;
  }
}

#alpha {
  position: absolute;
}

.content-wrapper {
  display: flex;
  position: relative;
  align-items: stretch;

  //  background-color: var(--c-primary);
  color: var(--c-white);
  border-radius: 4px;
  flex-wrap: wrap;
}

.content {
  position: relative;
  padding-bottom: 33%;
  width: 100%;
  flex: 1;
  flex-direction: column;
  display: flex;
  align-self: stretch;
  @include for-desktop-small {
    padding-bottom: 40%;
  }
  @include for-tablet {
    padding-bottom: 0;
  }

  .text {
    position: absolute;
    top: 0;
    right: 0;
    left: 20%;
    bottom: 0;
    padding: var(--spacer-base);
    background-image: url(/assets/images/fd_slider.webp);
    background-size: cover;
    background-position: top center;
    clip-path: url(#alphaPath);
    -webkit-clip-path: url(#alphaPath);
    @include for-tablet {
      clip-path: none;
      position: relative;
      left: 0;
    }
    @include for-mobile {
      clip-path: none;
      position: relative;
      left: 0;
    }

    &-content {
      margin: auto 0 auto auto;
      width: 65%;
      height: 100%;
      flex: 1;
      flex-direction: column;
      display: flex;
      align-self: stretch;
      @include for-tablet {
        width: 100%;
        margin: auto;
      }
      @include for-mobile {
        width: 100%;
        margin: auto;
      }

      .sf-heading {
        margin-top: var(--spacer-xl);
        margin-bottom: 0;
      }
    }
  }

  .order {
    font-size: var(--font-size--lg);
    // text-transform: uppercase;
    font-weight: bold;
    margin: 0.5rem 0;

    &-link {
      font-size: var(--font-size--lg);
      //  text-transform: uppercase;
    }

    &-text {
      line-height: 2;
    }
  }

}

.image {
  border-radius: 4px 0 0 4px;
  z-index: 0;
  position: absolute;
  top: 0;
  right: 45%;
  left: 0;
  bottom: 0;
  background-size: cover;
  background-position: right center;
  margin-right: 0;
  @include for-tablet {
    background-position: center bottom;
    position: relative;
    left: 0;
    right: 0;
    height: 420px;
    width: 100%;
  }
  @include for-mobile {
    position: relative;
    background-position: center bottom;
    left: 0;
    right: 0;
    height: 380px;
    width: 100%;
  }
}

.order-actions {
  margin: var(--spacer-base) 0 0 0;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;

  .sf-button {
    width: auto;
    flex: 40%;
    white-space: nowrap;
    min-height: 42px;
    padding: var(--spacer-sm) var(--spacer-xs);
    margin: var(--spacer-xs);

    &:first-of-type:not(:last-of-type) {
      margin: var(--spacer-sm) var(--spacer-sm) var(--spacer-sm) 0;
    }

    &:last-of-type:not(:first-of-type) {
      margin: var(--spacer-sm) 0 var(--spacer-sm) var(--spacer-sm);
    }

    @include for-mobile {
      flex: 100%;
      &:first-of-type:not(:last-of-type) {
        margin: 0;
        margin-top: var(--spacer-sm);
      }
      &:last-of-type:not(:first-of-type) {
        margin: var(--spacer-sm) 0 0;
      }
    }
  }
}

::v-deep {
  .sf-heading {
    text-align: left;
    margin: 0 0 var(--spacer-xl);

    &__title {
      color: var(--c-white);
      line-height: 2rem;
      text-align: center;
      margin: var(--spacer-xl) 0 var(--spacer-base);
    }
  }

  .sf-link {
    font-weight: bold;
    color: var(--c-white);

  }
}

</style>
